<section class="mt-3" [ngClass]="{'type-b': templateSuffix !== ''}">
  <app-counter
    [finishDateString]="dateFinished"
    [idCar]="idCard"
    *ngIf="dateFinished"
  >
  </app-counter>
  <div class="card-custom" *ngIf="summary.comment !== null ">
    <div class="coment-container">
      {{summary.comment}}
    </div>
  </div>
  <div class="card-custom">
    <div class="img-container">
      <img [src]="summary.carImage" alt="" />
    </div>

    <p class="text-color">
      Foto ilustrativa que no representa el color del auto seleccionado
    </p>

    <div class="card-body-custom">
      <div class="details-button mb-3" (click)="showDetails = !showDetails">
        {{ showDetails ? "Ocultar" : "Ver" }} detalles
      </div>
      <mat-accordion class="example-headers-align">
        <mat-expansion-panel
          class="no-click"
          [expanded]="showDetails"
          hideToggle
        >
          <mat-expansion-panel-header class="panel-header-title">
            <div class="title">
              <p class="brand">{{ summary.carTitle }}</p>
              <p class="sub-brand">{{ summary.carModel }}</p>
            </div>
          </mat-expansion-panel-header>

          <div class="expansion-body">
            <div class="item" *ngFor="let item of detailsArr">
              <p>{{ item.desc }}</p>
              <p>
                <strong> {{ item.value }} </strong>
              </p>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>

      <div class="item">
        <p>Entidad de seguro y placas</p>
        <p>
          <strong> {{ summary.state }} </strong>
        </p>
      </div>

      <div class="item">
        <p>Renta adelantada</p>
        <p>
          <strong> $ {{ summary.refund | number: "1.2-2" }} </strong>
        </p>
      </div>

      <div class="item">
        <p>Producto</p>
        <p>
          <strong>
            {{
              summary.concept === "afin" || summary.concept === "rr"
                ? "Rent2Buy"
                : (summary.concept | titlecase)
            }}
          </strong>
        </p>
      </div>

      <div class="item">
        <p>Plazo</p>
        <p>
          <strong> {{ summary.period }} meses </strong>
        </p>
      </div>

      <div class="item">
        <p [style]="getColor()">Pago Inicial Total</p>
        <p [style]="getColor()">
          <strong> $ {{ summary.initialPayment | number: "1.2-2" }} </strong>
        </p>
      </div>

      <div class="item">
        <p>Renta Mensual</p>
        <p>
          <strong> $ {{ summary.monthlyPayment | number: "1.2-2" }} </strong>
        </p>
      </div>

      <div class="item">
        <p>Aseguradora</p>
        <p>
          <strong> {{ summary.insurance }} </strong>
        </p>
      </div>

      <div class="se" >
        <mat-accordion>
          <mat-expansion-panel [expanded]="showDetailsCost" hideToggle>
            <mat-expansion-panel-header
              class="costos"
              (click)="showDetailsCost = !showDetailsCost"
            >
              <div class="title-cost">
                <span> Costos adicionales </span>
                <span>
                  {{ showDetailsCost ? "Ocultar" : "Ver" }} detalles
                </span>
              </div>
            </mat-expansion-panel-header>

            <div class="expansion-body-cost">
              <div>
                Costo de traslado depende de la localidad de origen de tu
                unidad.
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>

      <div class="d-flex justify-content-around" >
        <mat-slide-toggle (change)="changeCost($event)"> </mat-slide-toggle>
        <p style="font-size: 14px">
          Traslado {{ summary.additionalCost | currency }}
        </p>
      </div>

      <div class="btn-container">
        <button
          id="boton-lo-quiero-opcion-{{ option }}{{templateSuffix !== '' ? '-b' : ''}}"
          mat-button
          class="btn-danger-custom"
          [disabled]="isBlocked"
          (click)="changeCar(option)"
        >
          Lo quiero
        </button>
      </div>
    </div>
  </div>
</section>
